import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const footerBottomStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: ${pxToRem(theme.spacing['500'])};
	background-color: ${theme.colors.blanc.bgFooterBar};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		padding-left: ${pxToRem(theme.spacing['650'])};
		padding-right: ${pxToRem(theme.spacing['650'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		padding: ${pxToRem(theme.spacing['400'])} ${pxToRem(theme.spacing['500'])};
	}
`;
export const StyledFooterBottom = styled.div `
	${footerBottomStyles}
`;
const footerBottomContentStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${pxToRem(theme.spacing['450'])};
	width: 100%;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		gap: ${pxToRem(theme.spacing['400'])};
		max-width: ${pxToRem(theme.containerWidth.containerWidthMax)};
	}
`;
export const StyledFooterBottomContent = styled.div `
	${footerBottomContentStyles}
`;
